"use client"
/* */
import { jsxs, jsx } from 'react/jsx-runtime';
import { TabList } from './components/TabList/TabList.mjs';
import { flowComponent } from '../../lib/componentFactory/flowComponent.mjs';
import { TunnelProvider, TunnelExit } from '@mittwald/react-tunnel';
import clsx from 'clsx';
import { useState } from 'react';
import * as Aria from 'react-aria-components';
import styles from './Tabs.module.scss.mjs';

const Tabs = flowComponent("Tabs", (props) => {
  const {
    children,
    className,
    defaultSelectedKey,
    disabledKeys,
    ref,
    onSelectionChange,
    ...rest
  } = props;
  const rootClassName = clsx(styles.tabs, className);
  const [selection, setSelection] = useState(
    defaultSelectedKey
  );
  return /* @__PURE__ */ jsxs(TunnelProvider, { children: [
    children,
    /* @__PURE__ */ jsxs(
      Aria.Tabs,
      {
        slot: null,
        className: rootClassName,
        ...rest,
        selectedKey: selection,
        onSelectionChange: (key) => {
          setSelection(key);
          if (onSelectionChange) {
            onSelectionChange(key);
          }
        },
        disabledKeys,
        ref,
        children: [
          /* @__PURE__ */ jsx(
            TabList,
            {
              selection,
              onContextMenuSelectionChange: (key) => {
                setSelection(key);
                if (onSelectionChange) {
                  onSelectionChange(key);
                }
              },
              disabledKeys
            }
          ),
          /* @__PURE__ */ jsx(TunnelExit, { id: "Panels" })
        ]
      }
    )
  ] });
});

export { Tabs, Tabs as default };
//# sourceMappingURL=Tabs.mjs.map
